import * as React from 'react';
import { IValue as ImportedValue, TemplateCreateProvider } from './TemplateCreateProvider';
import { ActionTypes, TemplateCreateReducer } from './TemplateCreateReducer';
export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  types: string[];
}

export const defaultContextValues: IState = {
  types: [],
};

export const TemplateCreateStateContext = React.createContext<IState | undefined>(undefined);
export const TemplateCreateDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useTemplateCreateState() {
  const context = React.useContext(TemplateCreateStateContext);
  if (context === undefined) {
    throw new Error('useTemplateCreateState must be used within a TemplateCreateProvider');
  }
  return context;
}

function useTemplateCreateDispatch() {
  const context = React.useContext(TemplateCreateDispatchContext);
  if (context === undefined) {
    throw new Error('useTemplateCreateDispatch must be used within a TemplateCreateProvider');
  }
  return context;
}
export { TemplateCreateProvider, TemplateCreateReducer, useTemplateCreateState, useTemplateCreateDispatch };
